module.exports = new __parcel__URL__("bossfight_sit_out_button.a723c2b5.png").toString();